import Modal from "react-overlays/Modal";
import Icon from "./icon";

const renderBackdrop = (props) => <div className="backdrop" {...props} />;

const SubmitRequestModal = ({
  show,
  closeModal,
  labels,
  saveDraft,
  submitObject = { submitRequest: () => 0, isError: false },
  request,
  additionalDescription,
}) => {
  const { submitRequest, isError } = submitObject;

  const handleSubmitRequest = async () => {
    await submitRequest(request);
    closeModal();
  };

  return (
    <Modal
      show={show}
      onHide={closeModal}
      aria-labelledby="modal-label"
      className="modal modal--borse dark-mode"
      renderBackdrop={renderBackdrop}
      onBackdropClick={closeModal}
      aria-hidden="false"
      aria-modal="true"
    >
      <>
        <button
          type="button"
          onClick={closeModal}
          className="close-button"
          aria-label={labels?.CLOSE}
        >
          <Icon name="cross" />
        </button>
        <div className="modal__body wrapper">
          <h1 className="modal__title">
            {labels?.WELFARE_BORSE_SUBMIT_REQUEST ||
              "Once the request is sent you won't be able to edit the request"}
          </h1>
          {additionalDescription && <p className="modal__description">{additionalDescription}</p>}
          <p className="modal__description">
            {labels?.WELFARE_BORSE_SUBMIT_REQUEST_TEXT || "Do you want to send the request?"}
          </p>
          <div className="modal__buttons">
            <button className="button secondary" onClick={saveDraft}>
              {labels?.WELFARE_BORSE_SAVE_DRAFT || "Save draft"}
            </button>
            <button className="button primary" onClick={handleSubmitRequest}>
              {labels?.WELFARE_FORM_BTN_SEND || "Send"}
              <Icon name="paper-plane" />
            </button>
          </div>
          {isError && (
            <p className="modal__error">
              {labels?.WELFARE_BORSE_ERROR_SAVING_REQUEST || "Error saving request"}
            </p>
          )}
        </div>
      </>
    </Modal>
  );
};

export default SubmitRequestModal;
